import { BulkOperationTypeEnum } from './bulk-operation-type-enum';

export interface BulkOperationData<T> {
  data: T;
  operationType: BulkOperationTypeEnum;
}
